<template>
<g>
  <template v-for="(note, index) in blowbends" v-if="note && note.pitch">
    <harmap-cell :x="xCoord()" :y="yCoordBlowbend(index)" :pitch="note.pitch" :type="note.type" :key="note"></harmap-cell>
  </template>
  <harmap-cell :x="xCoord()" :y="yCoordBlownote()" :pitch="blownote" type="natural"></harmap-cell>
  <harmap-hole-number :x="xCoord()" :y="yCoordHolenumber()" :text="holeNumber + 1"></harmap-hole-number>
  <harmap-cell :x="xCoord()" :y="yCoordDrawnote()" :pitch="drawnote" type="natural"></harmap-cell>
  <template v-for="(note, index) in drawbends" v-if="note && note.pitch">
    <harmap-cell :x="xCoord()" :y="yCoordDrawbend(index)" :pitch="note.pitch" :type="note.type" :key="note"></harmap-cell>
  </template>
</g>
</template>

<script>
import HarmapCell from './HarmapCell'
import HarmapHoleNumber from './HarmapHoleNumber'

import { yCoord, CELL_SPACING, CELL_HEIGHT, MINI_CELL_HEIGHT } from '../grid'
import { HarmonicaHole } from '../harmonica'

export default {
  name: 'harmap-col',

  props: {
    hole: {
      type: HarmonicaHole,
      required: true
    },
    holeNumber: { type: Number, required: true },
    // x coordinate of the column
    x: { type: Number, required: true },
    // y coordinate of the column
    y: { type: Number, required: true },
    // maximum number of blow bends on the harmonica
    maxBlow: { type: Number, required: true },
    // maximum number of draw bends on the harmonica
    maxDraw: { type: Number, required: true }
  },

  components: { HarmapCell, HarmapHoleNumber },

  computed: {
    blownote () { return this.hole.blow },
    drawnote () { return this.hole.draw },
    blowbends () {
      const blowBends = this.hole.blowBends
      let finalBlowBends = []
      for (let i = 0; i < this.maxBlow; i++) {
        let note = {
          pitch: i <= blowBends.length ? blowBends[i] : null,
          type: this.hole.hasOverblows() ? 'over' : 'trad',
          direction: 'blow'
        }
        finalBlowBends.push(note)
      }
      finalBlowBends.reverse()
      return finalBlowBends
    },
    drawbends () {
      const drawBends = this.hole.drawBends
      let finalDrawBends = []
      for (let i = 0; i < this.maxDraw; i++) {
        let note = {
          pitch: i <= drawBends.length ? drawBends[i] : null,
          type: this.hole.hasOverdraws() ? 'over' : 'trad',
          direction: 'draw'
        }
        finalDrawBends.push(note)
      }
      return finalDrawBends
    }
  },

  methods: {
    xCoord () { return this.x },
    yCoordBlowbend (index) {
      let yOffset = this.y
      return yCoord(index, {yOffset, cellHeight: CELL_HEIGHT, cellSpacing: CELL_SPACING})
    },
    yCoordBlownote () {
      let yOffset = this.yCoordBlowbend(this.maxBlow)
      return yCoord(0, {yOffset, cellHeight: CELL_HEIGHT, cellSpacing: CELL_SPACING})
    },
    yCoordHolenumber () {
      let yOffset = this.yCoordBlowbend(this.maxBlow) + CELL_HEIGHT + CELL_SPACING
      return yCoord(0, {yOffset, cellHeight: CELL_HEIGHT, cellSpacing: CELL_SPACING})
    },
    yCoordDrawnote () {
      let yOffset = this.yCoordHolenumber() + MINI_CELL_HEIGHT + CELL_SPACING
      return yCoord(0, {yOffset, cellHeight: CELL_HEIGHT, cellSpacing: CELL_SPACING})
    },
    yCoordDrawbend (index) {
      let yOffset = this.yCoordDrawnote() + CELL_HEIGHT + CELL_SPACING
      return yCoord(index, {yOffset, cellHeight: CELL_HEIGHT, cellSpacing: CELL_SPACING})
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// HarmapCol.vue?1d6e2270